import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Npo } from '../../models/npo.model';
import {
    continuedToStripe,
    enrollmentSubmitted,
    npoSearched,
    npoSearchModalOpened,
    npoSelected,
    pageChanged,
    partnershipChanged,
    returnedFromStripe,
    reviewSectionClosed,
    showErrorsIfClean,
    successPageExited,
} from '../actions/dpp-enrollment.actions';
import { DppEnrollmentSelectors } from '../selectors/dpp-enrollment.selectors';

@Injectable({
    providedIn: 'root',
})
export class DppEnrollmentFacade {
    npoSearchRequest$ = this.selectors.npoSearchRequest$;
    enrollmentStatus$ = this.selectors.enrollmentStatus$;
    enrollmentStatusCallStatus$ = this.selectors.enrollmentStatusCallStatus$;
    selectedNpo$ = this.selectors.selectedNpo$;
    partnershipChanged$ = this.selectors.partnershipChanged$;
    npoSearchCallStatus$ = this.selectors.npoSearchCallStatus$;
    npoSearchResults$ = this.selectors.npoSearchResults$;
    returnedFromStripe$ = this.selectors.returnedFromStripe$;
    pageNumber$ = this.selectors.pageNumber$;
    hasSecondaries$ = this.selectors.hasSecondaries$;
    showErrorsIfClean$ = this.selectors.showErrorsIfClean$;

    constructor(
        private readonly store: Store,
        private readonly selectors: DppEnrollmentSelectors
    ) {}

    returnedFromStripe(digitalPayeeId: number): void {
        this.store.dispatch(returnedFromStripe({ digitalPayeeId }));
    }

    npoSearchModalOpened(): void {
        this.store.dispatch(npoSearchModalOpened());
    }

    reviewSectionClosed() {
        this.store.dispatch(reviewSectionClosed());
    }

    npoSearched(ein: string): void {
        this.store.dispatch(npoSearched({ ein }));
    }

    pageChanged(pageNumber: number): void {
        this.store.dispatch(pageChanged({ pageNumber }));
    }

    npoSelected(npo: Npo): void {
        this.store.dispatch(npoSelected({ npo }));
    }

    continuedToStripe(): void {
        this.store.dispatch(continuedToStripe());
    }

    enrollmentSubmitted(): void {
        this.store.dispatch(enrollmentSubmitted());
    }

    showErrorsIfClean(): void {
        this.store.dispatch(showErrorsIfClean());
    }

    successPageExited(): void {
        this.store.dispatch(successPageExited());
    }

    partnershipChanged(isPartnership: boolean): void {
        this.store.dispatch(partnershipChanged({ isPartnership }));
    }
}
